<app-web-product-template-list></app-web-product-template-list>

<lib-button-input-portal [portalKey]="'displayableContentKey'">
  <lib-button-primary (buttonClicked)="viewModel.openCreateWebProductTemplateModal()">
    Create Product Template
  </lib-button-primary>
</lib-button-input-portal>
